import { ConfigProvider, DatePicker } from "antd";
import dayjs from "dayjs";
import classes from "./Input.module.css";
import Commonformerror from "./CommonFormError";
import Commonformlabel from "./CommonFormLabel";
import { useEffect } from "react";

type Props = {
  value?: any;
  onChange?: (date: any, dateString: any) => void;
  style?: any;
  labelname?: string;
  required?: boolean;
  formate?: string;
  showTime?: boolean;
  ToDate: any;
  FromDate: any;
  picker?: any;
  size?: any;
  error?: any;
  touched?: any;
  name: string;
  nolabel?: boolean;
  DateType?: string;
  allowClear?: boolean;
};
export const CommonDatePicker = ({
  value,
  onChange,
  style,
  labelname,
  required = false,
  formate = "YYYY-MM-DD",
  ToDate = null,
  FromDate = null,
  showTime = false,
  picker = "date",
  size,
  error,
  touched,
  name,
  nolabel = false,
  DateType,
  allowClear = true,
}: Props) => {
  const disableFutureDt = (date: any, DateType: any) => {
    const fromdate = dayjs(FromDate);
    const todate = dayjs(ToDate);
    const currentdate = dayjs(new Date());

    if (DateType === "to_date") {
      if (dayjs(fromdate).format("YYYY-mm-DD") !== "Invalid Date" && fromdate) {
        return date?.isBefore(fromdate, "day");
      } else {
        return date?.isBefore(currentdate, "day");
      }
    } else if (DateType === "from_date") {
      return date?.isAfter(todate, "day");
    } else if (DateType === "future") {
      return date?.isAfter(new Date());
    }
    // return date?.isAfter(new Date());
  };

  return (
    <>
      {nolabel ? (
        ""
      ) : (
        <Commonformlabel labelname={labelname} required={required} />
      )}

      <ConfigProvider
        theme={{
          components: {
            DatePicker: {},
          },
        }}
      >
        <DatePicker
          showTime={showTime}
          format={formate}
          popupStyle={{ zIndex: 11000 }}
          placeholder={`${labelname}`}
          value={value ? dayjs(value) : null}
          onChange={onChange}
          style={{
            ...style,
            background: "#fff",
          }}
          className={classes.dateinput}
          disabledDate={(date) => disableFutureDt(date, DateType)}
          picker={picker}
          size={size}
          // allowClear={false}
          name={name}
          inputReadOnly={true}
          allowClear={allowClear}
        />

        <Commonformerror
          required={required}
          touched={touched}
          name={name}
          error={error}
        />
      </ConfigProvider>
    </>
  );
};
